import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormBuilder, FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { Component, forwardRef, Input } from '@angular/core';
import { DocumentationItem } from '../../../../model/documentation-item';
import { BehaviorSubject } from 'rxjs';

export const DOCUMENTATION_ITEM_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DocumentationItemControlComponent),
  multi: true,
};

@Component({
  selector: 'app-documentation-item-control',
  providers: [DOCUMENTATION_ITEM_CONTROL_VALUE_ACCESSOR],
  templateUrl: './documentation-item-control.component.html',
  styleUrls: ['./documentation-item-control.component.css']
})
export class DocumentationItemControlComponent implements ControlValueAccessor {

  onChange;
  @Input() isDisabled: boolean;
  @Input() loading: boolean;

  form: FormGroup;
  documentationItemsDataSource = new BehaviorSubject<AbstractControl[]>([]);
  displayDocumentationItemsColumns = ['name', 'description', 'carryPatient', 'info', 'star'];

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      DocumentationItems: this.formBuilder.array([])
    });

  }

  get documentationItems() { return <FormArray>this.form.get('DocumentationItems'); }

  writeValue(obj: DocumentationItem[]): void {
    if (obj) {
      this.addDocumentationItems(obj);
    } else {
      this.form.controls.DocumentationItems = this.formBuilder.array([]);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {

  }

  setDisabledState?(isDisabled: boolean): void {

  }

  addDocumentationItems(documentationItems: DocumentationItem[]): void {

    this.form.controls.DocumentationItems = this.formBuilder.array([]);

    documentationItems.forEach((item) => {
      const row = this.formBuilder.group({
        RequiredDocumentationId: [item.RequiredDocumentationId],
        DocumentationTypeId: [item.DocumentationTypeId],
        DocumentationItemAgreementId: [item.DocumentationItemAgreementId],
        MedicalAppointmentProcedureId: [item.MedicalAppointmentProcedureId],
        AgreementId: [item.AgreementId],
        Name: [item.Name],
        Description: [item.Description],
        Required: [item.Required],
        MakeWarning: [item.MakeWarning],
        CarryPatient: [ { value: item.CarryPatient, disabled: this.isDisabled }],
        Info: [ { value: item.Info , disabled: this.isDisabled }],
        MedicalAppointmentRequiredDocumentationId: [item.MedicalAppointmentRequiredDocumentationId]
      });

      row.controls.CarryPatient.valueChanges.subscribe(() => {
        this.onChange(<DocumentationItem[]>this.documentationItems.getRawValue());
      });

      row.controls.Info.valueChanges.subscribe(() => {
        this.onChange(<DocumentationItem[]>this.documentationItems.getRawValue());
      });

      this.documentationItems.push(row);
    });
    this.documentationItemsDataSource.next(this.documentationItems.controls);
  }

  displayName(index: number): string {
    return (<DocumentationItem>this.documentationItems.controls[index].value).Name;
  }

  displayDescription(index: number): string {
    return (<DocumentationItem>this.documentationItems.controls[index].value).Description;
  }
}
